import { AnimatedTextBlock } from "@components/atoms/AnimatedTextBlock"
import { BlockItem } from "@components/atoms/BlockItem"
import { BlockWrapper } from "@components/atoms/BlockWrapper"
import { Pill } from "@components/atoms/Pill"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { PieChart } from "react-minimal-pie-chart"

export const meta: BlockMeta = {
  title: "Home Research",
}

export default defineBlock("home/research", (props) => {
  return (
    <BlockWrapper toolbarState="hidden">
      <div className="flex flex-col w-full md:flex-row">
        <BlockItem className="bg-beige h-[114vw] flex justify-center items-center md:w-[calc(50%-4px)] md:mx-1 md:h-auto md:shrink-0" innerClassName="w-full self-stretch md:h-[45vw] flex flex-col justify-between md:items-center">
          <div className="w-full">
            <Pill className="bg-orange">
              <EditableText
                as="span"
                store="research-pill"
                inlineToolbar={false}
                defaultValue="The data"
                placeholder="The data"
              />
            </Pill>
            <AnimatedTextBlock textKey="research-title" className="mt-4" textClassName="type-body-m" triggerStart="top bottom-=15%" triggerEnd="bottom top" placeholder="Initial research indicates more than 50% of New Zealanders have a negative view towards Herpes. (TRA, 2024)" />
          </div>
          <div className="w-full h-full flex flex-col self-stretch justify-between">
            <div className="w-[65%] md:w-[53%] mx-auto justify-center items-center flex h-full">
              <PieChart
                data={[
                  { title: "Negative", value: 32, color: "#D14241" },
                  { title: "On the fence", value: 24, color: "#EBBE32" },
                  { title: "Positive", value: 44, color: "#7DDFBE" },
                ]}
                segmentsShift={1}
                radius={49}
                label={({ dataEntry }) => `${Math.round(dataEntry.percentage)} %`}
                labelStyle={{ fontSize: "5px", fontFamily: "ease", fontWeight: "normal", letterSpacing: "-0.1em", fill: "#000" }}
              />
            </div>
            <div className="flex gap-7">
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 md:w-5 md:h-5 rounded-sm bg-[#D14241]" />
                <p className="type-label-s md:type-label-m">Negative</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 md:w-5 md:h-5 rounded-sm bg-[#EBBE32]" />
                <p className="type-label-s md:type-label-m">On the fence</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 md:w-5 md:h-5 rounded-sm bg-[#7DDFBE]" />
                <p className="type-label-s md:type-label-m">Positive</p>
              </div>
            </div>
          </div>
        </BlockItem>
        <InnerBlocks
          template={[
            ["home/image-text", null],
          ]}
          templateLock="all"
          orientation="vertical"
        />
      </div>
    </BlockWrapper>
  )
})